import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
